import { BULK_PERMISSION_NAME } from '../../constants';
import type { AppPermissionDetails, AppRolePermissionForm } from '../../types';
import { extractToCategoryAndName } from '../extract-permission';

export function mapAppRolePermissionToForm(appRolePermission: AppPermissionDetails[]) {
  const form: AppRolePermissionForm = {};

  for (const row of appRolePermission) {
    if (row.type === 'feature') {
      const { category, name } = extractToCategoryAndName(row.id);

      const categoryPermissions = appRolePermission.filter(
        (permission) => permission.header === category,
      );

      const isPermissionUndefinedForCategory = (key: keyof AppPermissionDetails) =>
        categoryPermissions.every((permission) => permission[key] === undefined);

      const hasValidPermission = (key: keyof AppPermissionDetails) =>
        isPermissionUndefinedForCategory(key)
          ? undefined
          : categoryPermissions.every((permission) => permission[key] ?? true);

      const allPermissions = {
        view: hasValidPermission('view'),
        update: hasValidPermission('update'),
        create: hasValidPermission('create'),
        status: hasValidPermission('status'),
        delete: hasValidPermission('delete'),
      };

      form[category] = form[category] ?? {};

      form[category][name] = {
        view: row.view,
        update: row.update,
        create: row.create,
        status: row.status,
        delete: row.delete,
      };

      form[category][BULK_PERMISSION_NAME] = allPermissions;
    }
  }
  return form;
}
